<cdk-virtual-scroll-viewport [viUiItemSize]="isVirtualScrollActive ? rowHeight : null">
  <table mat-table
    matSort
    [ngClass]="{'compact': styleType === ITableStyleType.COMPACT, 'accessible': accessibilityMode, 'disabled': isLoading}"
    (matSortChange)="(isLoading || items.length <= 1) ? null : sortData($event)"
    [dataSource]="dataSource">

    <!--items columns definitions-->
    <ng-container *ngFor="let column of columnsConfig; let index = index; trackBy: trackByIndex">
      <ng-container matColumnDef="{{column.key}}">
        <!--column header-->
        <th mat-header-cell
          mat-sort-header="{{index}}"
          [disabled]="!column?.sortable || isLoading || items.length <= 1"
          [ngClass]="{'sortable': column?.sortable && !isLoading && items.length > 1}"
          [ngStyle]="{'width': column.width}"
          *matHeaderCellDef>
          {{column.name}}
        </th>

        <!--column cell-->
        <td mat-cell
          *matCellDef="let item"
          [ngStyle]="{'width': column.width}">
          <div *ngIf="!column.component"
            class="text-cell">
            {{column.formatter ? column.formatter( item[column.key]): item[column.key]}}
          </div>


          <div *ngIf="column.component"
            class="{{item}}">
            <ng-container #componentCell></ng-container>
          </div>

        </td>
      </ng-container>
    </ng-container>


    <!--select column definition-->
    <ng-container matColumnDef="{{SELECT_COLUMN}}">
      <th mat-header-cell
        class="select"
        *matHeaderCellDef>
        <vi-ui-rounded-checkbox *ngIf="allowMultiSelect"
          [tabindex]="0"
          [show]="headerRowHovered"
          [selected]="selection.hasValue() && isAllSelected()"
          (clicked)="toggleAllRows()"
          (keyup.space)="toggleAllRows()"
          (focusout)="showHeaderSelection = false"
          (focus)="showHeaderSelection = true">
        </vi-ui-rounded-checkbox>
      </th>
      <td mat-cell
        *matCellDef="let item; let i = index;"
        class="select">
        <vi-ui-rounded-checkbox [show]="isRowHovered(i)"
          [selected]="selection.isSelected(item)"
          [ariaLabelledby]="'row_' + i"
          (clicked)="toggleRow(item)">
        </vi-ui-rounded-checkbox>
      </td>
    </ng-container>

    <!--row definitions-->
    <tr mat-header-row
      [ngClass]="{'selectable': selectable && !isLoading}"
      *matHeaderRowDef="displayedColumns; sticky: true;"
      (mouseenter)="isLoading ? null : setHeaderHovered(true)"
      (mouseleave)="isLoading ? null : setHeaderHovered(false)">
    </tr>
    <tr mat-row
      [ngClass]="{'selectable': selectable && !isLoading, 'selected': selectable && !isLoading && selection.isSelected(row)}"
      [tabindex]="isLoading ? -1 : 0"
      *matRowDef="let row; let i = index; columns: displayedColumns;"
      id="{{'row_' + i}}"
      data-testid="table-row"
      (keyup.space)="(selectable && !isLoading) ? selection.toggle(row): null"
      (mouseenter)="isLoading ? null : setItemHovered(i, true)"
      (mouseleave)="isLoading ? null : setItemHovered(i, false)"
      (focusout)="isLoading ? null : setItemHovered(i, false)"
      (focus)="isLoading ? null : setItemHovered(i, true)">
    </tr>
  </table>

  @if (isLoading) {
  @if (loadingTemplate) {
  <ng-container [ngTemplateOutlet]="loadingTemplate"></ng-container>
  } @else {
  <div class="loading">
    <div class="rotating">
      <i class="i-vi-loading"></i>
    </div>
  </div>
  }
  }

  @if (!isLoading && !items.length) {
  <div class="empty-state">
    <ng-container [ngTemplateOutlet]="emptyStateTemplate"></ng-container>
  </div>
  }
</cdk-virtual-scroll-viewport>